import { ComponentProps } from 'react';
import { useFlag } from '@/features/unleash';

import { NarrativeKeyMetric } from './NarrativeKeyMetric';

type NarrativeKeyMetricProps = ComponentProps<typeof NarrativeKeyMetric>;

export const FlaggedNarrativeKeyMetric = (props: NarrativeKeyMetricProps) => {
  const { flagsReady, enabled, variant } = useFlag({
    name: 'mono-primary-narrative-company-report',
  });

  if (flagsReady && enabled && variant.name === 'variant') {
    return <NarrativeKeyMetric {...props} />;
  }

  return null;
};
